export const decl = (nArg = 0, root = '', ends = ['', '', '']) => {
  const n = Math.abs(nArg);
  let end;

  if (n % 10 === 1 && n % 100 !== 11) {
    end = 0;
  } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
    end = 1;
  } else {
    end = 2;
  }

  return root + ends[end];
};
